import asyncCom from '@/CommonDP/commons/asyncCom';

export const openDoc = async (props) => {
  const { default: DocDialog } = await import('./associate.vue');
  return asyncCom(DocDialog, undefined, props);
};
